<template>
  <!--普通模板-->
  <div class="general">
<!--    <role-tab-->
<!--      :tabs="{-->
<!--        // haveBind 表示是否要用 binds中的数据-->
<!--        haveBind: false,-->
<!--        binds: [],-->
<!--      }"-->
<!--      @change="tabHand"-->
<!--    />-->
    <template v-if="!isInDingTalk">
      <!--    我的模板-->
      <div class="sp">
        <h1 class="com-title com-ht">
          <span><i></i>我的模板&nbsp;&nbsp;</span>
          <el-tooltip effect="dark" placement="bottom-end">
            <div slot="content">
              <p style="margin-bottom: 10px">
                <img style="max-width: 18px; margin-right: 10px" src="/images/advancedVersion/pdf_1.png" alt="">
                <span>变量模板:创建时可以添加变量，发起时填写变量信息</span>
              </p>
              <p>
                <img style="max-width: 18px; margin-right: 10px" src="/images/advancedVersion/file_1.png" alt="">
                <span>仅上传文件:创建时无需添加变量，发起时可在线编辑文件内容</span>
              </p>
            </div>
            <span class="el-icon-question"></span>
          </el-tooltip>
          <span
            v-if="!isInDingTalk"
            class="to-temp-sty"
            >海量合同模板供您参考&nbsp;&nbsp;<a
              :href="`${GlobalConfig.domain.junziqanIndex}/contract_template.html`"
              target="_blank"
              style="color: #ec1c1c"
              >立即前往&gt;&gt;</a
            ></span
          >
        </h1>
        <div class="search">
<!--          <el-button class="data-btn" type="text" @click="addAdvanceTpl"-->
<!--            >自定义模板创建  &gt;&gt;-->
<!--          </el-button>-->
          <el-input
            v-model="templateName"
            placeholder="请输入模板名称"
            size="mini"
            clearable
          >
          </el-input>
          <el-button
            size="mini"
            @click="serchTemplate(templateName)"
            type="primary"
            icon="el-icon-search"
            class="searchIcon"
          ></el-button>
          <el-button
            size="mini"
            @click="templateName='',serchTemplate('')"
          >重置</el-button>
        </div>
      </div>
      <div class="box-wrap">
        <div class="temone" v-for="(item, index) in dataList" :key="index">
          <div class="t-box">
            <img
              v-if="beWord(item.tplName)"
              class="y-img"
              src="/images/advancedVersion/file_1.png"
            />
            <img v-else class="y-img" src="/images/advancedVersion/pdf_1.png" />
            <p>{{ item.tplName }}</p>
            <div class="msk">
              <div class="list_one" style="border-right: 1px solid #ffffff;">
                <span
                  class="el-icon-edit-outline"
                  style="margin-top: 1px"
                  @click="modulesEditFn(item)"
                  title="修改"
                ></span>
              </div>
              <div class="list_one">
                <span
                  class="el-icon-delete"
                  @click="delTpl(item)"
                  title="删除"
                ></span>
              </div>
            </div>
          </div>
          <!-- <div class="temone_switch" v-show="whetherSeniorUser">
            <span>打开后该印章可授权给成员</span>
            <switch-button
              v-model="item.allowMemberUse"
              :object="item"
              @confirmFn="seccondConfirmFn"
            ></switch-button>
          </div> -->
          <div class="a-btn" @click="templateUseFn(item)">{{ isInDingTalk? '去发起' : '立即使用'}}</div>
        </div>
        <div class="temone add">
          <div style="padding: 20px">
            <p>选择创建方式</p>
            <div style="text-align: center; margin-top: 5px">
              <div
                v-if="!isInDingTalk"
                class="add_button_style"
                style="margin: 0 auto; margin-bottom: 5px"
                @click="templateAddChoose(1)"
              >
                变量模板
              </div>
              <el-upload
                action="#"
                accept=".doc,.docx"
                multiple
                :limit="1"
                :before-upload="fileOnBeforeUpload"
                :on-exceed="fileHandleExceed"
                :show-file-list="false"
                :file-list="fileList"
                :on-error="fileOnError"
              >
                <div class="add_button_style">仅上传文件</div>
              </el-upload>
              <div
                class="add_button_style"
                style="margin: 0 auto; margin-bottom: 10px"
                @click="addAdvanceTpl"
              >
                HTML模板
              </div>
            </div>
          </div>
        </div>
        <!-- <div slot="reference" @click="templateAddChoose(0)" v-else> -->
        <!-- <div slot="reference" @click="templateAddChoose(1)">
          <div class="temone add">
            <span class="el-icon-plus"></span>
          </div>
        </div> -->
      </div>

      <!--    系统模板-->
      <!-- <h1 class="com-title com-ht"><i></i>系统模板</h1>
      <div class="box-wrap">
        <div class="temone" v-for="(item, index) in sysList" :key="index">
          <div class="t-box">
            <img class="y-img" src="/images/web/ye.png" />
            <p>{{ item.name }}</p>
          </div>
          <nuxt-link
            class="a-btn"
            :to="{
              path: '/tpl/add/sysContract',
              query: { typeName: item.typeName }
            }"
            >立即使用
          </nuxt-link>
        </div>
      </div> -->
    </template>

    <!--    API模板-->
    <template v-if="isShowApiList">
      <h1 class="com-title com-ht"><i></i>API模板</h1>
      <div class="box-wrap">
        <div
          class="temone temone-center"
          v-for="(item, index) in apiTemplateList"
          :key="index"
        >
          <div class="t-box">
            <img v-if="beWord(item.tplName)" src="/images/advancedVersion/file_1.png" class="y-img" alt="" />
            <img v-else src="/images/advancedVersion/pdf_1.png" class="y-img" alt="" />
            <p>{{ item.tplName }}</p>
            <div class="msk">
              <div class="list_one" style="border-right: 1px solid #ffffff;">
                <span
                  class="el-icon-edit-outline"
                  style="margin-top: 1px"
                  @click="
                  $store.getters.authUser.identityAuth > -1
                    ? $router.push({
                        path: '/tpl/add/api',
                        query: { tplId: item.tplId },
                      })
                    : (authDialog = true)
                "
                  title="修改"
                ></span>
              </div>
              <div class="list_one">
                <span
                  class="el-icon-delete"
                  @click="delApiTpl(item)"
                  title="删除"
                ></span>
              </div>
            </div>
          </div>
          <p class="tpid">
            ID:{{ item.serialNum }} <br />
            模板编码:{{ item.tplCode }}
          </p>
          <!--        <a class="a-btn">立即使用</a>-->
        </div>
        <div
          class="temone add"
          @click="
            $store.getters.authUser.identityAuth > -1
              ? $router.push({ path: '/tpl/add/api' })
              : (authDialog = true)
          "
        >
          <span class="el-icon-plus"></span>
        </div>
      </div>
    </template>

    <!--授权模板-->
    <div v-for="(item, index) in authorizationList" :key="index">
      <div class="sp">
        <h1 class="com-title com-ht"><i></i>授权给我的模板-<img
          src="/images/icon/dingIcon.png"
          alt="钉钉"
          width="20px"
          v-if="userNameFn(item.corpUserId).userStemFrom === -16 && !isInDingTalk"
        />{{userNameFn(item.corpUserId).corpName}}</h1>
<!--        <div class="search">-->
<!--          <el-input-->
<!--            v-model="templateName"-->
<!--            placeholder="请输入模板名称"-->
<!--            size="mini"-->
<!--            clearable-->
<!--          ></el-input>-->
<!--          <el-button-->
<!--            size="mini"-->
<!--            @click="serchTemplate(templateName)"-->
<!--            type="primary"-->
<!--            icon="el-icon-search"-->
<!--            class="searchIcon"-->
<!--          ></el-button>-->
<!--          <el-button-->
<!--            size="mini"-->
<!--            @click="templateName='',serchTemplate('')"-->
<!--          >重置</el-button>-->
<!--        </div>-->
      </div>
      <div class="box-wrap">
        <div
          class="temone"
          v-for="(childItem, childIndex) in item.list"
          :key="childIndex"
        >
          <div class="t-box">
            <img v-if="beWord(childItem.tplName)" src="/images/advancedVersion/file_1.png" class="y-img" alt="" />
            <img v-else src="/images/advancedVersion/pdf_1.png" class="y-img" alt="" />
            <p>{{ childItem.tplName }}</p>
          </div>

          <template v-if="isAdVn(childItem)">
            <div class="b-box">
              <a
                class="a-btn"
                @click="launchFn(childItem, item.corpUserId)"
                :style="childItem.signerFixed ? 'width:100%' : ' width:50%'"
                >立即发起
              </a>
              <a
                class="a-btn"
                @click="batchLaunchFn(childItem, item.corpUserId)"
                v-if="!childItem.signerFixed"
                >批量发起</a
              >
            </div>
          </template>
          <template v-else>
            <div
              @click="toApplyFn(childItem, item.corpUserId)"
              class="a-btn"
              >立即使用</div
            >
          </template>
        </div>
        <no-data v-if="!(item.list && item.list.length)" text="企业暂未授权模板给您，如需使用请联系管理员" slot="empty" />
      </div>
    </div>

    <goto-auth :authDialog.sync="authDialog"></goto-auth>

    <!--批量发起弹窗-->
    <batch-launch
      v-if="plDialogVisible"
      :show.sync="plDialogVisible"
      :tplId="batchTplId"
      :nowToken="nowToken"
    />
    <!-- onlyOffice -->
    <editor-pup
      :showofficeEditor.sync="showofficeEditor"
      :editor="editor"
      @saveLoading="saveLoading"
    ></editor-pup>
  </div>
</template>

<script>
  import RoleTab from "@/components/role-tab";
  import { isInDingTalk } from "@/assets/js/utils/ding-env";
import {
  ApiMethods,
  uploadFileAndConvertInfo
} from "@/assets/js/http-serve/http-methods";
import { listSystemTemplate } from "@/assets/js/http-serve/http-sysTpl";
import ElGo from "../../components/go/Go";
import BatchLaunch from "../../components/advancedVersion/batchLaunch";
import switchButton from "../../components/switch-button/index";
import GlobalConfig from "@/assets/js/config/global";
import { mapGetters } from "vuex"
import editorPup from "@/components/onlyOffice/editorPup.vue";
  import {getCorpToken, setCurrentUser, storeAllToken} from "../../assets/js/http-serve/corp/common";

export default {
  components: { ElGo, BatchLaunch, switchButton, editorPup, RoleTab },
  props: ['menus'],
  data () {
    return {
      nowToken: '', //模板批量临时corpUserId
      isInDingTalk,
      GlobalConfig,
      editor: {},
      showofficeEditor: false,
      fileList: [],
      loading: false,
      paged: { itemPage: 1, pageSize: 9999 },
      loadingList: false,
      dataList: [], // 我的模板
      sysList: [], // 系统模板
      apiTemplateList: [], // api模板
      authorizationList: [], // 授权给我的模板
      authDialog: false,
      templateName: "", //模板名称（搜索）
      // 批量发起
      plDialogVisible: false,
      batchTplId: null
    };
  },
  methods: {
    //userNameFn
    userNameFn(corpUserId) {
      let arr = this.bindCorpUsers.filter(item => {
        return +item.corpUserId === +corpUserId
      })
      return arr.length ? arr[0]: '';
    },
    tabHand () {
      try {
        if (this.$route.path === this.menus[0].route.path) return
        if (isInDingTalk) {
          this.$router.push({ path: this.menus[0].route.path }, () => { }, () => { })
        }
      } catch (err) {
        console.log('tplRouter_err', err)
      }
    },
    //批量发起
    batchLaunchFn(childItem, corpUserId) {
      getCorpToken(+corpUserId).then(result => {
        this.nowToken = result.data;
      })
      this.plDialogVisible = true;
      this.batchTplId = childItem.tplId;
    },
    //成员的立即使用按钮
    toApplyFn(item, corpUserId) {
      let user = this.userNameFn(corpUserId);
      setCurrentUser(user).finally(() => {
        this.$router.push({
          path: '/tpl/add/apply',
          query: { tplId: item.tplId, isAuth: 1 },
        })
      })
    },
    // 立即发起
    launchFn(item, corpUserId) {
      let user = this.userNameFn(corpUserId)
      setCurrentUser(user).finally(() => {
        if (this.beWord(item.tplName)) {
          // 纯文件模板
          this.$router.push({
            path: "/initiation/toCreate",
            query: {tplId: item.tplId}
          });
          return;
        } else {
          this.$router.push({
            path: '/advancedVersion/writeVariables',
            query: { id: item.tplId },
          })
        }
      });
    },
    // 调用loading并获取原文件
    saveLoading (sourceFile, tplId) {
      this.loadingStart();
      setTimeout(() => {
        // this.loadingClose();
        this.editedFile(sourceFile, tplId);
      }, 5 * 1000);
    },
    // 获取office编辑后的文件
    editedFile (sourceFile, tplId) {
      ApiMethods.onlyOfficeAPI.officeFile(sourceFile).then(res => {
        if (!res.success) return this.$message.error("网络异常，请重试");
        this.officePDFInfo({ ...res.data, tplId, tplFileType: 1 });
      });
    },
    // office编辑后转换
    officePDFInfo (fileInfo) {
      // this.loadingStart();
      const { fileName, targetId, fileType, tplId } = fileInfo;
      ApiMethods.AIDocSmart.converToPDF({ ...fileInfo }).then(res => {
        const { data } = res;
        if (res.success) {
          const file = {
            fileName: fileName,
            fileType: 1,
            tempFile: data.tempFile,
            items: data.items,
            sort: null,
            tplId,
            fileOperVO: {
              docHash: data.docHash,
              extendsLocation: "",
              fileName: fileName,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              targetIdForPreview: "",
              ts: data.tempFile.ts
            },
            sourceFile: fileInfo
          };
          this.fileList = [{ ...file, tplFileType: 1 }];
          this.onlyfileUp();
        } else {
          this.$message.error(res.description);
        }
        this.loadingClose();
      });
    },
    // onlyoffice 编辑
    InOnlyOffice (file) {
      const _this = this;
      this.loadingStart();
      ApiMethods.TemplateController.personVDetailByIDNom(file.tplId).then(
        res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          const { files } = res.data.context;
          const sourceFile = files[0].sourceFile;
          _this.openEditor(
            { fileName: files[0].fileName, ...sourceFile },
            file.tplId
          );
        }
      );
    },
    // 打开编辑器
    openEditor (sourceFile, tplId) {
      ApiMethods.onlyOfficeAPI
        .getOfficeConfig(sourceFile)
        .then(res => {
          console.log("res", res);
          if (!res.success) return this.$message.error(res.description);
          const { data } = res;
          this.editor = {
            // width: "100%", height: "100%",
            editorConfig: { ...data },
            sourceFile,
            fileIndex: tplId
          };
          this.showofficeEditor = true;
        })
        .finally(() => {
          this.loadingClose();
        });
    },
    // 判断文件是否是doc类型
    beWord (fileName) {
      let filesuffix = "";
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      return filesuffix === "doc" || filesuffix === "docx";
    },
    fileOnError (err) {
      console.log("文件上传出错", err);
      this.loadingClose();
    },
    // 选取文件超过数量提示
    fileHandleExceed (files, fileList) {
      let num = files.length + fileList.length;
      if (num > 1) {
        return this.$message.error(
          `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${num} 个文件`
        );
      }
    },
    // 新增多文件上传
    fileOnBeforeUpload (file) {
      if (this.fileList.length >= 30) {
        return this.$message.error("当前可上传的文件不能超过30个！");
      }
      const re = new RegExp("(.doc|.docx)$", "i");
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!re.test(file.name)) {
        return this.$message.error("文件格式只能是doc/docx的文件");
      }
      if (!isLt20M) {
        return this.$message.error("上传文件大小不能超过 20MB!");
      }
      this.loadingStart("文件上传中~");
      uploadFileAndConvertInfo({
        file: file,
        fileType: 1,
        fileName: file.name,
        saveSourceFile: 1
      })
        .then(data => {
          const resInfo = {
            fileName: data.fileName,
            sourceFile: data.sourceFile,
            tplFileType: 1,
            tempFile: data.tempFile
          };
          this.fileList = [resInfo];
          this.onlyfileUp();
          this.loadingClose();
        })
        .catch(err => {
          console.log("err", err);
          this.loadingClose();
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 仅文件上传模板
    onlyfileUp () {
      this.loadingStart("正在保存文件模板~");
      const file = this.fileList[0];
      const param = {
        tplName: file.tplName || file.fileName,
        orderFlag: false,
        // inputGroups: file.inputGroups,
        // signers: this.signers,
        // 文件上传信息
        files: this.fileList,
        useTo: 1 // 仅文件上传
        // groupIdSet: this.selectNodes // 授权多个部门 id
      };
      if (file.tplId) param.tplId = file.tplId;
      console.log("param", param);
      ApiMethods.TemplateController.versionOperTpl(param).then(res => {
        if (res.success) {
          // 保存草稿弹窗
          this.$message.success("保存成功");
          this.fileList = [];
          this.queryList(this.templateName);
        } else {
          this.$message.error(res.description || this.$tip);
        }
        this.loadingClose();
      });
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      this.loading = this.$loading({
        lock: true,
        text: "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 新增高级模板
    addAdvanceTpl () {
      this.$router.push({
        // path: "/tpl/add/general",
        path: "/authEdit/variableEditor", //替换新编辑器地址-1903
      });
    },
    //我的模板编辑
    modulesEditFn (item) {
      if (this.beWord(item.tplName)) {
        this.InOnlyOffice(item);
        return false;
      }
      if (this.$store.getters.authUser.identityAuth > -1) {
        //是否是高级用户
        if (this.whetherSeniorUser) {
          switch (item.tplVersion) {
            case 1:
              this.$router.push({
                // path: "/console/authEdit",
                path: item.editorType ? "/authEdit/variableEditor" : "/console/authEdit", //替换新编辑器地址-1903
                query: { tplId: item.tplId }
              });
              break;
            case 2:
              this.$router.push({
                path: "/advancedVersion/addTpl",
                query: { id: item.tplId }
              });
              break;
            default:
              this.$router.push({
                // path: "/tpl/add/general",
                path: item.editorType ? "/authEdit/variableEditor" : "/tpl/add/general", //替换新编辑器地址-1903
                query: { tplId: item.tplId}
              });
              break;
          }
        } else {
          switch (item.tplVersion) {
            // case 1:
            //   this.$router.push({
            //     path: "/console/authEdit",
            //     query: { tplId: item.tplId }
            //   });
            //   break;
            case 2:
              this.$router.push({
                path: "/tpl/add/addTplPerson",
                query: { id: item.tplId, userType: 0 }
              });
              break;
            default:
              this.$router.push({
                // path: "/tpl/add/general",
                path: item.editorType ? "/authEdit/variableEditor" : "/tpl/add/general",  //替换新编辑器地址-1903
                query: { tplId: item.tplId }
              });
              break;
          }
        }
      } else {
        this.authDialog = true;
      }
    },
    //我的模板立即使用
    templateUseFn: function (item) {
      if (item.tplVersion === 2 && item.status === 1) {
        return this.$message.warning("模板未完成，请发布后使用");
      } else if (this.isInDingTalk) {
        // 纯发起
        this.$router.push({
          path: "/initiation/toCreate",
        });
        return;
      }
      if (this.beWord(item.tplName)) {
        // 纯文件模板
        this.$router.push({
          path: "/initiation/toCreate",
          query: {tplId: item.tplId}
        });
        return;
      }
      if (this.whetherSeniorUser) {
        switch (item.tplVersion) {
          case 1:
            this.$router.push({
              path: "/tpl/add/apply",
              query: { tplId: item.tplId, isAuth: 1 }
            });
            break;
          case 2:
            this.$router.push({
              path: "/advancedVersion/writeVariables",
              query: { id: item.tplId }
            });
            break;
          default:
            this.$router.push({
              path: "/tpl/add/apply",
              query: { tplId: item.tplId }
            });
            break;
        }
      } else {
        let pathUrl =
          item.tplVersion == 2
            ? {
              path: "/advancedVersion/writeVariables",
              query: { id: item.tplId, userType: 0 }
            }
            : { path: "/tpl/add/apply", query: { tplId: item.tplId } };
        this.$router.push({
          path: pathUrl.path,
          query: pathUrl.query
        });
      }
    },
    //添加模板按钮
    templateAddChoose: function (val) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        val
          ? this.$router.push({ path: "/tpl/add/addTplPerson" })
          : this.$router.push({
            // path: "/tpl/add/general",
            path: "/authEdit/variableEditor", //替换新编辑器地址-1903
          });
      } else {
        this.authDialog = true;
      }
    },
    //二次确认函数
    seccondConfirmFn: function (switchVal, object) {
      return new Promise((resolve, reject) => {
        if (switchVal) {
          ApiMethods.TemplateController.allowMemberUseTem({
            tplId: object.tplId,
            tplVersion: object.tplVersion
          }).then(res => {
            if (res.success && res.code === "0") {
              resolve();
              this.$confirm("开启成功，是否前往授权？", "系统提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  // this.$router.push({path: '/console/setting?activeName=tab-template'});
                  this.$router.push({
                    path: "/console/template",
                    query: { activeName: "mianSign" }
                  });
                })
                .catch(() => { });
            } else {
              this.$message.error(res.description || res.msg);
            }
          });
        } else {
          this.$confirm(
            "关闭之后授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续?",
            "系统提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(async () => {
              //prohibitMemberUserTem关闭成员使用模板
              let res = await ApiMethods.TemplateController.prohibitMemberUserTem(
                {
                  tplId: object.tplId,
                  tplVersion: object.tplVersion
                }
              );
              if (res.success && res.code === "0") {
                resolve();
                this.$message.success("关闭成功");
              } else {
                this.$message.error(res.description || res.msg);
              }
            })
            .catch(() => { });
        }
      });
    },
    templateDelFn: async function (target) {
      let param = { tplId: target.tplId };
      let result = "";
      if (this.whetherSeniorUser) {
        switch (target.tplVersion) {
          case 1:
            result = await ApiMethods.TemplateController.delTplV1(param);
            break;
          case 2:
            result = await ApiMethods.TemplateController.delTplV2(param);
            break;
          default:
            result = await ApiMethods.TemplateController.delTpl(param);
            break;
        }
      } else {
        switch (target.tplVersion) {
          // case 1:
          //   result = await ApiMethods.TemplateController.delTplV1(param);
          //   break;
          case 2:
            result = await ApiMethods.TemplateController.personDelTpl(param);
            break;
          default:
            result = await ApiMethods.TemplateController.delTpl(param);
            break;
        }
      }
      if (result.success) {
        this.$alert("操作成功", "系统提示", {
          confirmButtonText: "确定",
          callback: action => {
            this.queryList(this.templateName);
          }
        });
      } else {
        this.$message.error(result.description || this.$tip);
      }
    },
    delTpl: function (target) {
      var _this = this;
      _this
        .$confirm(
          "删除之后，该模板将彻底消失，授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续？",
          "系统提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          this.templateDelFn(target);
        })
        .catch(() => { });
    },
    handleCurrentChange: function (val) {
      this.paged.pageNum = val;
      this.queryList(this.templateName);
    },
    handleSizeChange: function (val) {
      this.paged.pageSize = val;
      this.queryList(this.templateName);
    },
    /**
     *  我的模板
     * */
    queryList (name,toast) {
      console.log(this.$store.getters.currentAuthUser, "[[[");
      let param = {
        itemPage: this.paged.pageNum,
        pageSize: this.paged.pageSize,
        tplName: name,
        deleteCtToken: true
      };
      this.loading = true;
      ApiMethods.TemplateController.listTpl(param)
        .then(result => {
          if (result.success) {
            if (toast) this.$message.success('操作成功')
            this.dataList = result.data;
            this.paged = {
              pageNum: result.pageNum,
              pageSize: result.pageSize,
              pages: result.pages,
              total: result.total
            };
          } else {
            if (this.$store.getters.authUser.identityAuth > -1)
              this.$message.error(result.description || this.$tip);
            return;
          }
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    /**
     *  api模板
     * */
    apiList: function (name) {
      let param = {
        ...this.paged,
        // tplGroupTypeId:this.operGroupType.tplGroupTypeId
        tplName: name
      };
      ApiMethods.ApiTemplateController.listTpl(param)
        .then(result => {
          if (result.success) {
            this.apiTemplateList = result.data;
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    /**
     *  删除api模板
     * */
    delApiTpl: function (target) {
      var _this = this;
      _this
        .$confirm("此操作将永久删除该模板, 是否继续?", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          var param = { tplId: target.tplId };
          ApiMethods.ApiTemplateController.delTpl(param).then(result => {
            if (result.success) {
              _this.$alert("操作成功", "系统提示", {
                confirmButtonText: "确定",
                callback: action => {
                  _this.apiList(_this.templateName);
                }
              });
            } else {
              _this.$alert(result.description || "操作失败", "系统提示");
            }
          });
        })
        .catch(() => { });
    },
    /**
     *  系统模板
     * */
    listSysTpl: function () {
      listSystemTemplate().then(({ data }) => {
        let arr = [];
        // 体验签署放最前面
        data.map(item => {
          if (item.typeName === "exper") {
            arr.unshift(item);
          } else {
            arr.push(item);
          }
        });
        this.sysList = arr;
      });
    },
    /**
     *  授权给我的模板
     * */
    queryAuthorizationList (name, tokenRes) {
      const param = { ...this.paged, tplName: name };
      // if (!this.$store.getters.consoleToken) return false;
      ApiMethods.TemplateController.authTpl({
        ...param,
        _ctToken: tokenRes.token,
      })
        .then(result => {
          if (!result.success)
            return this.$message.error(result.description || this.$tip);
          this.authorizationList.push({corpUserId: tokenRes.corpUserId, list: result.data})
        })
        .finally(() => {
          // this.loadingList = false
        });
    },

    // 当前是否高级模板
    isAdVn (item) {
      return +item.tplVersion === 2;
    },
    // 搜索模板
    serchTemplate (name) {
      this.queryList(name,1);
      this.isShowApiList && this.apiList(name);
      // this.isShowAuthorizationList && this.queryAuthorizationList(name);
    }
  },
  computed: {
    //是否是高级企业用户
    whetherSeniorUser () {
      let currentAuthUser = this.$store.getters.currentAuthUser;
      let allAuthUser = this.$store.getters.allAuthUser;
      //判断是不是普通账号（超级管理员绑定在普通账号）true: 高级用户
      return (
        currentAuthUser &&
        currentAuthUser.userType == 1 &&
        allAuthUser &&
        allAuthUser.corpCreateFlag == 1
      );
    },
    /**
     *  是否显示api模板
     * */
    isShowApiList () {
      // 查询 API 模板分类（企业用户激活API）
      if (
        this.$store.getters.currentAuthUser &&
        this.$store.getters.currentAuthUser.merchantFlag === 1
      ) {
        return true;
      }
      return false;
    },
    /**
     *  是否显示授权模板
     * */
    isShowAuthorizationList () {
      if (
        this.$store.getters.currentAuthUser &&
        (this.$store.getters.currentAuthUser.userType == 1 ||
          this.$store.getters.currentAuthUser.superFlag !== undefined) &&
        this.$store.getters.currentAuthUser.superFlag !== undefined
      ) {
        return true;
      }
      return false;
    },
    isCorpUser () {
      try {
        return this.$store.getters.currentAuthUser.superFlag !== undefined;
      } catch (e) {
        return false;
      }
    },
    bindCorpUsers() {
      return this.$store.getters.allAuthUser.bindCorpUsers;
    }
  },
  watch: {
    isShowApiList (newValue) {
      this.apiList(this.templateName);
    },
    isShowAuthorizationList (newValue) {
      // this.queryAuthorizationList(this.templateName);
    },
    "$store.state.currentAuthUser.corpUserId": {
      deep: true,
      handler (val) {
        if (!val) {
          this.queryList(this.templateName);
        }
      },
      immediate: true
    }
  },
  created () {
    this.isShowApiList && this.apiList(this.templateName);
    this.listSysTpl();
  },
  mounted() {
    storeAllToken(res => {
      if(isInDingTalk){
      const DINGUSER = JSON.parse(sessionStorage.getItem('dingloginInfo'));
      const CURR = this.bindCorpUsers.find(item => item.corpId === DINGUSER.jzqCorpId);
      (res.corpUserId == CURR.corpUserId) && this.queryAuthorizationList(this.templateName, res);
      }else{
        this.queryAuthorizationList(this.templateName, res);
      }
    });
  },
  name: "general"
};
</script>

<style lang="less" scoped>
.to-temp-sty {
  margin-left: 20px;
  font-size: 14px;
  > a {
    &:active {
      color: #ec1c1c;
    }
  }
}
.data-btn {
  width: 120px;
  margin-right: 20px;
  color: #dedbdc;
  &:hover {
    //   background: none;
    //   border: none;
    color: #dedbdc;
  }
}
.add_button_style {
  width: 120px;
  margin-bottom: 5px;
  color: #ffffff;
  padding: 6px 10px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  background-color: #ec1c1c;
}
.general {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 1200px;
  margin: 0 auto;
}

.tpl-table {
  border: 1px solid #ebebeb;
  border-bottom: 0;

  .action span {
    margin-right: 10px;
    cursor: pointer;
  }
  .action .span {
    margin-right: 10px;
  }
}

.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
  min-height: 85px;
}

.box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: -20px;
  margin-top: -15px;
  padding: 15px;
  /*&:last-child {*/
  /*  margin-bottom: 130px;*/
  /*}*/
  .temone {
    margin-left: 20px;
    margin-top: 15px;
    width: 175px;
    text-align: center;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    &.add {
      cursor: pointer;
      height: 140px;
      /*line-height: 140px;*/
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
      }
    }
    &.temone-center {
      height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .t-box {
        width: 100%;
        height: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        .y-img {
          margin-top: 0;
        }
      }
      .tpid {
        width: 100%;
        height: 32%;
        background: #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .temone_switch {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 12px;
      padding-bottom: 10px;
    }
    .t-box {
      position: relative;
      height: 105px;
      overflow: hidden;
      &:hover {
        .msk {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
      }
      .y-img {
        width: 46px;
        height: 54px;
        display: block;
        margin: 17px auto 7px auto;
      }
      p {
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 10px;
        width: 100%;
        font-family: Source Han Sans SC;
        color: rgba(41, 2, 2, 0.65);
        box-sizing: border-box;
      }
      .msk {
        transition: all ease 0.2s;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        padding: 8px 8px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        .list_one {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50%;
        }
        span {
          cursor: pointer;
          float: right;
          color: #ffffff;
          font-size: 20px;
          margin-left: 10px;
          &:hover {
            color: rgba(236, 28, 28, 1);
          }
        }
      }
    }

    .b-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        width: 50%;
      }
    }
    .el-icon-plus {
      cursor: pointer;
      color: #c9bfbf;
      font-size: 80px;
    }
  }
}

.a-btn {
  cursor: pointer;
  display: block;
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(41, 2, 2, 1);
  text-decoration: none;
  border-radius: 0px 0px 4px 4px;
  background: rgba(239, 239, 239, 1);
  &:hover {
    color: rgba(236, 28, 28, 1);
    /*background:rgba(236,28,28,1);*/
  }
}

.search {
  display: flex;
  align-items: center;
  margin-right: 20px;
  border-radius: 4px;

  /deep/ .el-input__inner {
    border-radius: 4px 0 0 4px;
  }
  .searchIcon {
    padding: 7px 10px;
    border-radius: 0 3px 3px 0;
    background: rgb(222, 219, 220);
    border: 1px solid rgb(222, 219, 220);

    &:hover {
      background: #ec1c1c;
      border: 1px solid #ec1c1c;
    }
  }
}

.com-ht {
  /*justify-content: flex-start;*/
}

.sp {
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .com-ht {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/general.vue